import crypto from 'crypto';

export const hashMd5 = value =>
  crypto
    .createHash('md5')
    .update(value)
    .digest('hex');

export default { hashMd5 };
